import { useState, useEffect } from 'react';
import { Tabs, Space, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { DisabledByDefaultRounded, Done } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, TextField, Typography } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Tab2 from './Tab2';
import { useNavigate } from 'react-router-dom';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Caisse from '../../../../Models/Caisse';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import PrintClotureSystemCaisse from '../../../Prints/PrintClotureSystemCaisse';
import { PrintClotureSystemeCaisseDirect, PrintEtatCaisseDirect } from '../../../../utilitaires/globalFunction';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ManageSystemeCaisse = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(false)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<Caisse[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false)
  const [recep, setRecep] = useState(false)
  const [codeOpe, setCodeOpe] = useState("")
  const [codeSecret, setCodeSecret] = useState("")



  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(false)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
    setRecep(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let so = form.getFieldValue("CODOPE")
    let numCaisse = form.getFieldValue("NODECE")
    let caiUti = form.getFieldValue("CAIUTI")
    setRadioaCheck(false)
    setImpActive(true)
    //setData([])
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    localStorage.setItem(Data.LocalVariable.Mainreset, "1")
    localStorage.setItem(Data.LocalVariable.resetTable, "1")
    form.setFieldValue("CODOPE", so)
    form.setFieldValue("NODECE", numCaisse)
    form.setFieldValue("CODOPE", "");
    form.setFieldValue("CAIUTI", caiUti);
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [

    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détaille caisse
        </span>
      ),
      children: <Tab2 form={form} />, //form={form}
    }
  ];

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  function printTab(opt: string) {

    const col: ColumnsType<any> = [
      {
        title: 'N°',
        dataIndex: 'NODECE',
      },
      {
        title: 'Nom caisse',
        dataIndex: 'LECEON',
      },
      {
        title: 'Caissier(ère)',
        dataIndex: 'NMURCR',
      },
      {
        title: 'Compte',
        dataIndex: 'NUMCPT',
      },
      {
        title: 'Nombre de Versement',
        dataIndex: 'NUMVER',
      },
      {
        title: 'Nombre de Retrait',
        dataIndex: 'NUMRET',
      },
      {
        title: 'Total Versement',
        dataIndex: 'CLOSVT',
      },
      {
        title: 'Total Retrait',
        dataIndex: 'CLOSPT',
      },
      {
        title: 'Emission',
        dataIndex: 'MTEMCOFF',
      },
      {
        title: 'Reception',
        dataIndex: 'MTRECOFF',
      },
      {
        title: 'Solde cloture',
        dataIndex: 'EETSRL',
      },
      // {
      //   title: 'Solde veille',
      //   dataIndex: 'CLOSVT',
      // },
    ];

    var newData = []

    var tNbVer = 0;
    var tNbRet = 0;
    var tFondEm = 0;
    var tFondRec = 0;
    var tSldCl = 0;
    var tSldVeil = 0;

    
    var tCLOSVT = 0;
    var tCLOSPT = 0;

    data.map((e: any) => {
      tNbVer += e.NUMVER
      tNbRet += e.NUMRET
      tFondEm += e.MTEMCOFF
      tFondRec += e.MTRECOFF
      tSldCl += e.CLOSPT
      tSldVeil += e.CLOSVT
      
      tCLOSVT += e.CLOSVT;
      tCLOSPT += e.CLOSPT;

      newData.push({
        "NODECE": e.NODECE,
        "LECEON": e.LECEON,
        "NMURCR": e.NMURCR,
        "NUMCPT": e.NUMCPT,
        
        "CLOSVT": e.CLOSVT,
        "CLOSPT": e.CLOSPT,

        "NUMVER": formatNumber(e.NUMVER),
        "NUMRET": formatNumber(e.NUMRET),
        "MTEMCOFF": formatNumber(e.MTEMCOFF),
        "MTRECOFF": formatNumber(e.MTRECOFF),
        "EETSRL": formatNumber(e.EETSRL),
        // "CLOSVT": formatNumber(e.CLOSVT)
      })
    })

    newData.push({
      "NODECE": "",
      "LECEON": "",
      "NMURCR": "",
      "NUMCPT": "",
      
      "CLOSVT": "",
      "CLOSPT": "",

      "NUMVER": "",
      "NUMRET": "",
      "MTEMCOFF": "",
      "MTRECOFF": "",
      "EETSRL": "",
      // "CLOSVT": ""
    })
    newData.push({
      "NODECE": "Totaux",
      "LECEON": "",
      "NMURCR": "",
      "NUMCPT": "",
      
      "CLOSVT": formatNumber(tCLOSVT),
      "CLOSPT": formatNumber(tCLOSPT),

      "NUMVER": formatNumber(tNbVer),
      "NUMRET": formatNumber(tNbRet),
      "MTEMCOFF": formatNumber(tFondEm),
      "MTRECOFF": formatNumber(tFondRec),
      "EETSRL": formatNumber(tSldCl),
      // "CLOSVT": formatNumber(tSldVeil)
    });

    // select NUMVER, NUMRET from CAI

    localStorage.setItem(Data.LocalVariable.tabCaisse, JSON.stringify({ "columns": col, "data": newData, "form": { titre: `ETAT ${opt == 'C' ? 'CLOTURE' :opt == 'O' ? 'OUVERTURE' : ''} SYSTEME CAISSE` } }))

    // navigate("/till/close/print");

    PrintClotureSystemeCaisseDirect(user.codage,user.agence,user.nomuti,user.codage,user.coduti)

  }

  const onFinish = (opt: string) => {

    let userOpe : Utilisateur = user
    userOpe.jeton = opt

    SweetAlert.fire({
      title: "Effectuer "+((opt == 'C')? "la cloture" : "l'ouverture")+" du système caisse?",
      showCancelButton: true,
      color: "#116599",
      confirmButtonText: "Yes",
      confirmButtonColor: "#116599",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {
        try {

          setLoading(true);
          setIsSubmit(true)

          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.ManageSystemeCaisse,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(userOpe)),
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                //alert(res.StatutCode)
                if (res.StatutCode == 200) {
                  SweetAlert.fire({ title: res.Message, icon: "success" })

                  setImpActive(false)

                  // Impression Recu

                  printTab(opt)
                  // localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify(data))
                  // navigate("/operation/Deposit&withdrawal/print")

                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })

                  setImpActive(true)
                }
                consult()
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })

        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }
      }
    })
  };



  function consult() {
    //let search: ParamsPicklist = { CodeAgence: user.codage, Table: "CAI", Colonne1: "AEGECE", Colonne2: "", Colagence: '101', Init: user.codage, Choix: 33 }
     let search: ParamsPicklist = { CodeAgence: user.codage, Table: "CAI", Colonne1: "AEGECE", Colonne2: "", Colagence: '101', Init: user.codage, Choix: 35 }

    //let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
    initialiazeButton()
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {

            setData(res.Result.Table)

            var count1 = 0
            var count = 0

            for (let index = 0; index < (res.Result.Table as []).length; index++) {
              const element: Caisse = (res.Result.Table as [])[index];
              if (!(element.CDETAT == '52' || element.CDETAT == '53')) {
                count1++
              }
              if (element.CDETAT == '53') {
                count++
              }

            }

            setEnregActve(count == (res.Result.Table as []).length)
            setImpActive(count != (res.Result.Table as []).length)

          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  const columns: ColumnsType<any> = [
    {
      title: 'N° caisse',
      dataIndex: 'NODECE',
    },
    {
      title: 'Intitulé ',
      dataIndex: 'LECEON',
    },
    {
      title: 'Code caissier(ère)',
      dataIndex: 'NMURCR',
    },
    {
      title: 'Nom caissier(ère)',
      dataIndex: 'CAIUTI',
    },
    {
      title: 'Compte caisse',
      dataIndex: 'NUMCPT',
    },
     {
      title: 'Solde ouverture',
      dataIndex: 'EEDTJE',
    },
     {
      title: 'Total versements',
      dataIndex: 'CLOSVT',
    },
     {
      title: 'Total retraits',
      dataIndex: 'CLOSPT',
    },
     {
      title: 'Solde cloture',
      dataIndex: 'EEPEAE',
    },
    {
      title: 'Etat Caisse',
      dataIndex: 'CDETAT',
      render: (_, record) => (
        <Space size="middle" style={{ backgroundColor: (record.CDETAT == '52') ? "rgba(0, 255, 0, .3)" : (record.CDETAT == '53') ? "rgba(0, 0, 0, .2)" : "rgba(255, 0, 0, .3)", width: "100%", borderRadius: "3px", fontWeight: "bold" }}>
          {record.CDETAT} {(record.CDETAT == '52' || record.CDETAT == '53') ? <Done /> : <DisabledByDefaultRounded />}
        </Space>
      ),
    }
  ];

  if (pageLoad) {
    setPageLoad(false)
    consult()
  }
  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' disabled={enregActve} className='bt_add' onClick={()=>{onFinish('C')}} type="ghost" htmlType="submit" block>
                  Cloturer
                </Button>
                <Button size='large' disabled={!enregActve} className='bt_add' onClick={()=>{onFinish('O')}} type="ghost" htmlType="submit" block>
                  Ouvrir
                </Button>
                <Button size='large' className='bt_add' type="ghost" onClick={consult} block>
                  Actualiser
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" onClick={()=>{
                  printTab("");
                }} block>
                  Aperçu
                </Button>
                <Button size='large' onClick={handleAnulle} className='bt_add' type="ghost" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElementAuto' marginTop={"-25%"}>
                <Form disabled={radioaCheck}>
                  <legend>Etats de caisses</legend>
                  
                  <Table size='small' style={{ width: 'auto' }} columns={columns} dataSource={data} scroll={{ y: 250, x: 10 }} pagination={false} />
                </Form>
              </Box>
               
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default ManageSystemeCaisse;